import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: "isInsideFilter"
})
export class isInsideFilterPipe implements PipeTransform {

    transform(array: any[], query: string, champ: Array<string> = []): any {
        if (query) {
          query = query.toLowerCase();
          //recuperation de la liste de tous les champs
          if(champ.length === 0){
            champ = Object.getOwnPropertyNames(array[0]);
          }
          let new_data = array.filter((elem)=>{
            let retour = false;
            //pour chaque propriété existante dans l'objet
            champ.forEach(function(val, idx, array) {
              //si on trouve la chaine
              if(
                elem !== null
                && elem.hasOwnProperty(val)
                && elem[val] !== null
                && elem[val].toLowerCase().indexOf(query) > -1
              ){
                //on renvoi l'element
                retour = true;
                return true;
              }
            });
            return retour;
          });
          return new_data;
        }
        return array;
    }
}
